import React from 'react';
import styles from "./DenyConfirmPopUp.module.css";
import Modal from "react-modal";
import Button from "../../../components/common/button/Button";
import {confirmAPI} from "../../../services/admin";
import {ReportStatus} from "../../../types/document";

interface DenyConfirmPopUpProps {
    isOpen: boolean;
    onClose: () => void;
    reportId: number;
}
//보고서 반려 팝업
const DenyConfirmPopUp: React.FC<DenyConfirmPopUpProps> = ({
                                                               isOpen,
                                                               onClose,
                                                               reportId
                                                           }) => {
    //보고서 생략
    const handleDeny = async () => {
        try {
            //보고서 처리 API
            await confirmAPI({
                reportId,
                reportStatus: ReportStatus.반려 //반려 처리
            });
            onClose();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    //보고서 재생성, 보고서 자동생성 코드 연결 필요
    const handleRegenerate = async () => {
        try {
            onClose();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className={styles.modal}
            overlayClassName={styles.overlay}
        >
            <div className={styles.container}>
                <div className={styles.header}>
                    <h2 className={styles.title}>보고서 반려</h2>
                    {/*닫기 버튼*/}
                    <button
                        onClick={onClose}
                        className={styles.closeButton}
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>
                <div className={styles.buttonContainer}>
                    {/*재생성 버튼*/}
                    <Button
                        variant="primary"
                        onClick={handleRegenerate}>
                        재생성
                    </Button>
                    {/*생략 버튼*/}
                    <Button
                        variant="primary"
                        onClick={handleDeny}>
                        생략
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default DenyConfirmPopUp;